/**
 * Safely check whether an error's `message` contains a substring.
 *
 * tRPC mutation `onError` callbacks type the error as having `message: string`,
 * but runtime errors can violate that (e.g. a non-standard error object whose
 * `message` is undefined). Calling `.includes()` on such a value throws
 * `TypeError: can't access property "includes", message is undefined`.
 * Use this helper instead of `error.message.includes(...)` when branching on
 * error text so a missing/non-string message falls through to generic handling.
 */
export const errorMessageIncludes = (error: unknown, substring: string): boolean => {
  const message = (error as { message?: unknown } | null | undefined)?.message
  return typeof message === "string" && message.includes(substring)
}
